import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '入门指南', path: '/category/rumen-zhinan' },
      { label: '资源推荐', path: '/category/ziyuan-tuijian' },
      { label: '入口地址', path: '/category/rukou-dizhi' },
      { label: '使用技巧', path: '/category/shiyong-jiqiao' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '常见问题', path: '/category/changjian-wenti' },
      { label: '最新动态', path: '/category/zuixin-dongtai' },
      { label: '关于我们', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
    ],
  },
  {
    title: '热门文章',
    links: [
      { label: '91暗是什么', path: '/article/91an-shi-shenme-wanzheng-jiedu' },
      { label: '91暗入口地址', path: '/article/91an-rukou-zuixin-dizhi-2026' },
      { label: '91暗使用技巧', path: '/article/91an-shiyong-jiqiao-gaoxiao' },
      { label: '91暗最新动态', path: '/article/91an-zuixin-dongtai-gengxin-2026' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="font-heading text-xl font-bold text-background-50 hover:text-primary-300 transition-colors cursor-pointer">
              91暗指南
            </Link>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">
              致力于为用户提供91暗相关的最全面、最权威的信息指南与资源整合。帮助每位用户快速了解91暗的全貌，找到最符合需求的内容与入口。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-300 hover:text-primary-300 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 91暗指南. 本站为信息聚合平台，所有内容仅供参考。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-400 hover:text-primary-300 transition-colors cursor-pointer" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-400 hover:text-primary-300 transition-colors cursor-pointer" rel="nofollow">
                使用条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}